import {
  FETCH_JOB_ALERT,
  FETCH_JOB_ALERT_SUCCESS,
  FETCH_JOB_ALERT_FAILED,
  SAVE_JOB_ALERT,
  SAVE_JOB_ALERT_SUCCESS,
  SAVE_JOB_ALERT_FAILED,
  DELETE_JOB_ALERT,
  DELETE_JOB_ALERT_SUCCESS,
  DELETE_JOB_ALERT_FAILED,
  UPDATE_ADD_STATUS_EMPTY,
  FETCH_THANK_YOU,
  FETCH_THANK_YOU_SUCCESS,
  FETCH_THANK_YOU_FAILED,
  FETCH_USER_CVS_FAILED,
  FETCH_USER_CVS_SUCCESS,
  FETCH_USER_CVS, 
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  isFormProcessing: false,
  isDeleting: false,
  content: {},
  alerts: null,
  error: false,
  addStatus: 0,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_JOB_ALERT:
      return {
        ...state,
        isLoading: true,
        content: {},
      };
    case FETCH_JOB_ALERT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload,
        alerts: payload.alerts,
      };
    case UPDATE_ADD_STATUS_EMPTY:
      return {
        ...state,
        addStatus: 0,
      };
    case FETCH_JOB_ALERT_FAILED:
      return {
        ...state,
        isLoading: false,
        content: {},
        error: payload,
      };
    case SAVE_JOB_ALERT:
      return {
        ...state,
        isFormProcessing: true,
      };
    case SAVE_JOB_ALERT_SUCCESS:
      return {
        ...state,
        isFormProcessing: false,
        alerts: payload.alerts,
        addStatus: payload?.status,
      };
    case SAVE_JOB_ALERT_FAILED:
      return {
        ...state,
        isFormProcessing: false,
        error: payload,
      };
    case DELETE_JOB_ALERT:
      return {
        ...state,
        isDeleting: true,
      };
    case DELETE_JOB_ALERT_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        alerts: payload.alerts,
      };
    case DELETE_JOB_ALERT_FAILED:
      return {
        ...state,
        isDeleting: false,
        error: payload,
      };
    case FETCH_THANK_YOU:
      return {
        ...state,
        isLoading: true,
        content: {},
      };
    case FETCH_THANK_YOU_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload,
      };
    case FETCH_THANK_YOU_FAILED:
      return {
        ...state,
        isLoading: false,
        content: {},
        error: payload,
      };
    case FETCH_USER_CVS:
      return {
        ...state,
        isLoading: true,
        content: {},
      };
    case FETCH_USER_CVS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload,
      };
    case FETCH_USER_CVS_FAILED:
      return {
        ...state,
        isLoading: false,
        content: {},
        error: payload,
      };
    default:
      return state;
  }
}
